module.exports = __webpack_public_path__ + "static/media/rain-and-sleet-mix.c2f1dd80.svg";